import React from 'react'
import PrimaryTheme from '../../Themes/Primary'
import Input from '../../components/Input'
import Header from '../../components/Header'
import AlertDialogSlide from '../../components/Dialog'
import { useDispatch, useSelector } from 'react-redux'
import ForgotPassword from '../../components/ForgotPassword'
import { getAggregatorUser, login } from '../../redux/actions/userActions'
import AlertModal from '../../components/Modal'
import Alert from '../../components/Alert'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'
import { Reducers, Tokens } from '../../Interfaces/Interfaces'
import { decode } from 'jsonwebtoken'
import Banner from '../../components/Banner'
import { getCurrentUser } from '../../redux/actions/CoordinatorActions'
import { isBreakStatement } from 'typescript'

export default function LandingPage() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const alert = useSelector((state: Reducers) => state.alert);

  const [page, setPage] = React.useState(false)
  const [emailValid, setEmailValid]: any = React.useState(null);
  const [email, setEmail]: any = React.useState('');
  const [password, setPassword]: any = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  const [visible, setVisibility] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const [error, setError] = React.useState('');



  
var UserType = {
  Aggregator:5,
  Coordinator:8,
  UserPersonnel:9
};

  const handleOpen = (page: boolean) => {
    setPage(page)
    dispatch({
      type: 'MODAL',
      payload: true
    })
  };

  // const handleClose = () => {
  //   dispatch({
  //     type: 'MODAL',
  //     payload: false
  //   })
  // };

  const handleSubmit = () => {

    // hide password
    setVisibility(false);
    setError('');
    setHasError(false);

    // open spinner
    dispatch({
      type: 'LOADING',
      payload: true
    });

    setSubmitted(true);

    // e.preventDefault();

    let user = {
      username: email,
      password: password,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
      grant_type: 'password'
    };

    dispatch(login(user));
  };

  React.useEffect(() => {
    // let token = {
    //   client_id: 'client',
    //   client_secret: 'secret',
    //   grant_type: 'client_credentials'
    // };

    // dispatch(getToken(token))

  }, [dispatch]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        setError(alert.message);
        setHasError(true);

        // if (alert.message === 'Network request failed') {
        //   history.push('/networkError');
        // }

        dispatch({
          type: 'ALERT',
          payload: {}
        });
        dispatch({
          type: 'LOADING',
          payload: false
        });

        setSubmitted(false);

      } else {

        // dispatch({
        //   type: 'ALERT_MODAL',
        //   payload: false
        // });

        // enqueueSnackbar(alert.message, { variant: "success" });

        switch (alert.message) {

          case ' Recovery email sent successful': {
            dispatch({
              type: 'ALERT',
              payload: {}
            });

            dispatch({
              type: "LOADING",
              payload: true
            });
            break;
          }

          case 'Logged in': {
            // send user to dashboard

            window.location.href = '/dashboard';
            break;
          }

          case 'Login successful': {

            // wait for tokens to be set
            setTimeout(() => {
              let store = JSON.parse(localStorage.getItem('persist:root') || '{}');
              const tokens: Tokens = JSON.parse(store.tokens);

              if (Object.entries(tokens).length !== 0) {
                const decoded: any = decode(tokens.access_token);

                var userType =parseInt(decoded.user_type);

                switch(userType){
                  case UserType.Aggregator:
                    case UserType.UserPersonnel:
                    dispatch(getAggregatorUser());
                    break;
                    case UserType.Coordinator:
                      dispatch(getCurrentUser(tokens.access_token));
                    break;
                    default:

                      setError("Invalid User");
                      setHasError(true);
               
                      dispatch({
                        type: 'ALERT',
                        payload: {}
                      });
                      dispatch({
                        type: 'LOADING',
                        payload: false
                      });
              
                      setSubmitted(false);
                       break;
                    
                }
                // if (decoded.user_type === '5') {
                //   dispatch(getUser());
                // } else {
                //   dispatch(getCurrentUser(tokens.access_token));
                // }
              }
            }, 300)
            break;
          }


          default:
            dispatch({
              type: "LOADING",
              payload: false
            });

            break;
        }
        // if (alert.message !== "Recovery mail sent") {
        // 
        // }

        // if (alert.message === 'Logged in') {
        //   history.push('/dashboard');
        // }

        // if (alert.message === 'Login successful') {
        //   setTimeout(() => {
        //     let store = JSON.parse(localStorage.getItem('persist:root') || '{}');
        //     const tokens: Tokens = JSON.parse(store.tokens);

        //     if (Object.entries(tokens).length !== 0) {
        //       const decoded: any = decode(tokens.access_token);

        //       if (decoded.user_type === '5') {
        //         dispatch(getUser());
        //       } else {
        //         dispatch(getCurrentUser(tokens.access_token));
        //       }
        //     }


        //   }, 3000);
        // }
      }
    }
  }, [dispatch, enqueueSnackbar, alert, history]);

  const validateEmail = (text: string) => {
    // email pattern
    let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (!reg.test(text)) {
      setEmailValid(false);
      setEmail(text.toLowerCase());
    } else {
      setEmailValid(true);
      setEmail(text);
    }
  };

  return (
    <div style={{ backgroundColor: PrimaryTheme.surface }}>

      <div className="row m-0" style={{
        backgroundColor: PrimaryTheme.surface,
      }}>

        <Header classNames="d-md-none" />

        {/* form */}
        <div className="col-md-6 hero-left" style={{
          backgroundColor: "white", //'rgb(0 149 224)',
          minHeight: '100vh',
          height: 'auto',
          // backgroundImage: "url('/hero.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}>

          <a className="navbar-brand" href="/" style={{
            fontFamily: PrimaryTheme.fonts?.RubikLight,
            marginTop: 40,
          }}>
            <img src="/logo-blue.png" width="150" className="d-inline-block align-top" alt="" loading="lazy" />
          </a>

          <h1 className="" style={{
            marginTop: 100,
            fontFamily: PrimaryTheme.fonts?.BoldFont,
            color: PrimaryTheme.primary,
            fontSize: PrimaryTheme.fontSizes?.heading,
            textTransform: "uppercase"
          }}>Welcome!</h1>
          <p style={{
            fontFamily: PrimaryTheme.fonts?.RegularFont,
            fontSize: PrimaryTheme.fontSizes?.body,
            color: PrimaryTheme.primary,
          }}>Onboard & manage agents</p>

          <div className="col-md-9 p-0 mr-auto" style={{
            marginTop: 50
          }}>
            <form noValidate>

              {hasError && <Banner
                className="bq-danger"
                text={error}
                iconColor={PrimaryTheme.bqDanger}
              />}

              <Input
                type='email'
                placeholder='Email'
                autoComplete="email"
                showIcon
                required
                valid={emailValid}
                value={email}
                disabled={submitted}
                inputMode="email"
                onChange={e => validateEmail(e.target.value)}
                isInput
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                  backgroundColor: PrimaryTheme.background
                }} />

              <Input
                type={visible ? "text" : "password"}
                // valid={password.length > 1 ? true : false}
                value={password}
                placeholder='Password'
                required
                isPassword
                showIcon
                visibilityIcon={visible ? "visibility_off" : "visibility"}
                inputMode="text"
                disabled={submitted}
                onChange={e => setPassword(e.target.value)}
                onIconClick={() => setVisibility(!visible)}
                isInput style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                  backgroundColor: PrimaryTheme.background
                }} />
              <Input
                onClick={handleSubmit}
                type='submit'
                isInput
                value='Login'
                disabled={!emailValid || password.length === 0 || submitted}
                style={{
                  backgroundColor: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }} className='text-bold border-0' />

              <div className="form-group text-center">
                <button onClick={() => handleOpen(true)} type="button" className="btn btn-link text-dark outline-0">Forgot password?</button>
              </div>

            </form>
          </div>
        </div>

        {/* hero image */}
        <div className="col-md-6 d-none d-md-block hero-right" style={{
          background: PrimaryTheme.surface,
          minHeight: '100vh',
          height: 'auto',
          paddingTop: 18,
          backgroundColor: 'rgb(0 149 224)',
          backgroundImage: "url('/hero.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}>
          <div className="row justify-content-end">
            <ul className="navbar nav">
              {/* <li className='nav-item'>
                <button onClick={() => handleOpen(2)} className="btn nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.dark
                }} >Become A Merchant</button>
              </li> */}
              <li className='nav-item'>
                <a className="nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.white
                }} href="https://bankly.ng/about-us" target="_blank" rel='noreferrer noopener' >About Us</a>
              </li>
              <li className='nav-item'>
                <a className="nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.white
                }} href="mailto:support@bankly.ng">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {page && <AlertDialogSlide >
        <ForgotPassword />
      </AlertDialogSlide>}

      <AlertModal>
        <Alert
          title="Successful"
          body="An email has been sent to the provided email address."
          value={"Done"}
          onClick={() => dispatch({ type: "ALERT_MODAL", payload: false })}
        />
      </AlertModal>

    </div>
  )
}
